var map = {
	"./tenor(0).gif": "0814",
	"./tenor(1).gif": "c436",
	"./tenor(10).gif": "7890",
	"./tenor(11).gif": "b145",
	"./tenor(12).gif": "b5e8",
	"./tenor(13).gif": "e657",
	"./tenor(14).gif": "c4b7",
	"./tenor(15).gif": "23b6",
	"./tenor(2).gif": "0eaa",
	"./tenor(3).gif": "cfa1",
	"./tenor(4).gif": "48da",
	"./tenor(5).gif": "223d",
	"./tenor(6).gif": "d528",
	"./tenor(7).gif": "df92",
	"./tenor(8).gif": "b1dc",
	"./tenor(9).gif": "593b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bc16";